import { DevTool } from "@hookform/devtools";
import { FC, type PropsWithChildren } from "react";
import { FormProvider } from "react-hook-form";

import { useCrudEditContext, useEditFormProvider } from "@ryde/redux";
import { IExtendableDto, shouldDebugForms } from "@ryde/shared";

export const DrawerFormProviderWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const {
    data: { dto, isEdit, isDuplicate },
    entity,
  } = useCrudEditContext<IExtendableDto>();

  const { methods, control } = useEditFormProvider({
    entity,
    isEdit: Boolean(isEdit),
    isDuplicate: Boolean(isDuplicate),
    dto,
  });

  return (
    <FormProvider {...methods}>
      {children}
      {shouldDebugForms() && <DevTool control={control} />}
    </FormProvider>
  );
};
